import { IOption } from 'models/Form';
import { IHierarchyItem } from 'services/userService';

export const Flatten = (
  currentItem: IHierarchyItem,
  destination: IOption<string>[],
  level?: number
) => {
  const _level: number = level ? level : 0;
  destination.push({
    label: currentItem.name,
    value: currentItem.id,
    recursionLevel: _level,
  });
  var items = currentItem.children.sort((a, b) => {
    return a.name.toLowerCase() < b.name.toLowerCase()
      ? -1
      : b.name.toLowerCase() > a.name.toLowerCase()
        ? 1
        : 0;
  });
  items.map((c) => Flatten(c, destination, _level + 1));
};
